import { Component, OnInit } from '@angular/core';
import { Router,  ActivatedRoute, NavigationEnd } from '@angular/router';
import { IApplicationStep } from '../models/application-step.interface';
import { filter } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';

@Component({
  selector: 'online-app-application-edit',
  templateUrl: './application-edit.component.html',
  styleUrls: ['./application-edit.component.css'],
  host: {
    class: 'application-component-after-login'
  }
})
export class ApplicationEditComponent implements OnInit {

  previousButtonVisible = false;
  saveButtonText = 'Save & Continue';
  applicationId = 0;

  previousSectionURL = '';
  nextSectionURL = '';
  currentSectionURL = '';


  applicationSteps: IApplicationStep[] = [];
  //   {
  //     Id: 1,
  //     Description: 'Important Information',
  //     URL: 'important-information'
  //   },
  //   {
  //     Id: 2,
  //     Description: 'Student Details',
  //     URL: 'student-details'
  //   },
  //   {
  //     Id: 3,
  //     Description: 'Parent Guardian Details',
  //     URL: 'parent-guardian-details'
  //   },
  // ];

  applicationState: any;

  constructor(private router: Router,
              private applicationService: ApplicationService,
              private store: Store<any>,
              private activatedRoute: ActivatedRoute) {}

  ngOnInit() {

  //   this.currentSectionURL = this.router.url;

  //   this.updateButtons();
  //   this.updateURLs();

  //   this.activatedRoute.params.subscribe(params => {
  //     this.applicationId = +params['id']; // (+) converts string 'id' to a number
  //  });

  //   this.router.events.pipe( filter(event => event instanceof NavigationEnd) )
  //       .subscribe((navigationEndEvent: NavigationEnd) => {
  //         this.currentSectionURL = navigationEndEvent.url;
  //         this.updateButtons();
  //         this.updateURLs();
  //       });

  //   this.store.pipe(select('application'))
  //             .subscribe( applicationState => {
  //                 this.applicationState = applicationState;
  //               });

  }

  updateButtons() {

    const isImportantInformationSection = this.currentSectionURL.endsWith('important-information');
    if (isImportantInformationSection) {
      this.previousButtonVisible = false;
      this.saveButtonText = 'Continue';
    } else {
      this.previousButtonVisible = true;
      this.saveButtonText = 'Save & Continue';
    }
  }

  isApplicationStepExists(applicationStepId: number): boolean {
    return this.applicationSteps.filter( step => step.Id === applicationStepId).length === 1
             && applicationStepId > 0 && applicationStepId <= this.applicationSteps.length;
  }

  getSectionURL(applicationStepId: number): string {
    // Arrays start with 0 based index whereas application step id starts with 1
    const applicationStepIndex = applicationStepId - 1;
    return this.isApplicationStepExists(applicationStepId) ? this.applicationSteps[applicationStepIndex].URL : null;

  }

  updateURLs() {
    const currentSectionURL = this.currentSectionURL.split('/').pop();
    const currentApplicationStep = this.applicationSteps.filter( step => step.URL === currentSectionURL).pop();

    this.previousSectionURL = this.getSectionURL(currentApplicationStep.Id - 1);
    this.nextSectionURL = this.getSectionURL(currentApplicationStep.Id + 1);
  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', this.previousSectionURL]);
  }

  saveCurrentSectionData() {
    const currentSection = this.currentSectionURL.split('/').pop();

    switch (currentSection) {
      case 'important-information':
        this.router.navigate(['/applications', this.applicationId, 'edit', this.nextSectionURL]);
        break;
      case 'student-details':
        //console.log('going to update student details');
        //console.log(this.applicationState.studentDetails);
        this.applicationService.updateStudentDetails(this.applicationId, this.applicationState.studentDetails)
            .subscribe( (response: SingleResultApiResponse) => {
              //console.log('successfully updated student details');
            this.router.navigate(['/applications', this.applicationId, 'edit', this.nextSectionURL]);
        }, err => {
          //console.log('error in updateStudentDetails api');
          console.error(err);
        });
        break;


    }


  }

  saveAndContinue() {
    this.saveCurrentSectionData();
  }

}
